<template>
  <Icon class="close-button" :class="elClasses" @click.native="$emit('click', $event)">
    {{ close }}
  </Icon>
</template>

<script>
/**
 * Simple component with a close icon
 *
 * @vue-prop {Boolean} absolute - Use an absolute positioning at the top right
 * @vue-prop {Boolean} white - Set the icon color to white
 */

// Components
import Icon from '@/components/icon.vue';
// Utils
import { close } from '@/assets/icons/';

export default {

  name: 'CloseButton',

  components: {
    Icon,
  },

  props: {
    absolute: {
      type: Boolean,
      default: true,
    },
    white: Boolean,
  },

  data() {
    return {
      close,
    };
  },

  computed: {
    /** Object: Classes applied to this.$el */
    elClasses() {
      return {
        'close-button--absolute': this.absolute,
        'close-button--white': this.white,
      };
    },
  },

};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.close-button {
  color: $color-shizen-blue;
  padding: 0.5em;
  width: 1.3em;
  height: 1.3em;
  z-index: 10005;
  border-radius: $main-border-radius;
  cursor: pointer;

  &--absolute {
    position: absolute;
    top: .8rem;
    right: .8rem;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  &--white {
    color: #fff;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
}
</style>
